import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type Props = {
  onPrev: () => void;
  onNext: () => void;
};

const arrowSx = {
  position: 'absolute' as const,
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 10,
  bgcolor: 'background.paper',
  boxShadow: 2,
  '&:hover': { bgcolor: 'background.paper' },
};

const StackArrows = ({ onPrev, onNext }: Props) => (
  <>
    <IconButton className="tb-cards-arrow-left" onClick={onPrev} sx={{ ...arrowSx, left: -20 }}>
      <ChevronLeftIcon />
    </IconButton>
    <IconButton className="tb-cards-arrow-right" onClick={onNext} sx={{ ...arrowSx, right: -20 }}>
      <ChevronRightIcon />
    </IconButton>
  </>
);

export default StackArrows;
